import { useRemoteConfigPayload } from '@/lib/config/remote-config'

import { useIsSupportUser } from './support-user'

export const APP_BANNER_HEIGHT_PX = 48

export type AppBannerId = 'maintenance' | 'support'

export const useAppBanners = (): AppBannerId[] => {
  const isSupportUser = useIsSupportUser()
  const { payload: maintenancePayload } = useRemoteConfigPayload('maintenance-banner')

  const banners: AppBannerId[] = []
  if (maintenancePayload) banners.push('maintenance')
  if (isSupportUser) banners.push('support')
  return banners
}
